export const INITIAL_GEOLOCATION = {
  lat: 43.644379939764086,
  lng: -79.39865381355503,
}

export const spacesOptions = {
  "Meeting Room": "Meeting-Space",
  "Private Office": "Private-Office",
  "Flexday Suite": "Flexday-Suite",
}
